import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      let tabWidth = 160;
      if (['-1','99'].includes(this.searchParams.okbStatus)) {
        tabWidth = 220;
      }
      let columns = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '业务员姓名',
          key: 'userName',
          minWidth: 200,
          fixed: 'left',
          align: 'center',
          slot: 'userName'
        },
        {
          title: '状态',
          minWidth: 120,
          align: 'center',
          fixed: 'left',
          slot: 'status'
        }
      ];
      if (this.searchParams.okbStatus == -1) {
        columns.push({
          title: '提现类型',
          key: 'withdrawType',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            const withdrawType = params.row.withdrawType;
            return <span>{withdrawType == '2'?'支付宝':'银行卡'}</span>;
          }
        });
      }
      // ok保提现成功显示
      if (this.searchParams.okbStatus != 99) {
        columns.push({
          title: '金额',
          key: 'netIncome',
          minWidth: 140,
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '结算主体',
          key: 'settlementEntity',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '所属机构',
          key: 'orgName',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '所属团队',
          key: 'groupName',
          minWidth: 160,
          align: 'center'
        }
      ]);
      if (this.searchParams.okbStatus == 3) {
        columns.push({
          title: '申请时间',
          key: 'requestTime',
          align: 'center',
          width: 140,
          show: true,
          render(h, params) {
            const res = params.row.requestTime;
            return h('div', filter.filterTime(res, 'YYYY-MM-DD HH:mm'));
          }
        });
      } else {
        columns.push(
          {
            title: '证件类型',
            key: 'cardType',
            minWidth: 130,
            align: 'center'
          },
          {
            title: '证件号',
            slot: 'idNo',
            minWidth: 180,
            align: 'center'
          },
          {
            title: '银行预留手机号',
            slot: 'mobile',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '开户行',
            key: 'bank',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '银行账号',
            slot: 'cardNo',
            minWidth: 200,
            align: 'center'
          },
          {
            title: '支付宝账号',
            slot: 'alipayAccount',
            minWidth: 200,
            align: 'center'
          }
        );
      }
      // ok保提现成功显示
      // if (this.searchParams.okbStatus == 1) {
      //   columns.push({
      //     title: '打款账户',
      //     key: 'accountName',
      //     minWidth: 240,
      //     align: 'center'
      //   });
      // }
      columns.push({
        title: '操作',
        slot: 'action',
        className: 'action-columns',
        width: tabWidth,
        fixed: 'right',
        align: 'center'
      });
      this.columns = columns;
    }
  }
};
